import React, { useContext } from "react";
import AppContext from "../Context/AppContext";
import { CSSTransition } from "react-transition-group";
import Vote from "./Vote";
import ChatArea from "../ChatArea";
import { Container } from "./style";

const withTurn = (WrappedRole) => ({ ...props }) => {
  const { turn } = useContext(AppContext);

  return (
    <>
      {turn === "vote" ? (
        <CSSTransition
          in={turn === "vote"}
          classNames="page"
          timeout={500}
          unmountOnExit
        >
          <Vote />
        </CSSTransition>
      ) : turn === "night" ? (
        <CSSTransition
          in={turn === "night"}
          classNames="page"
          timeout={500}
          unmountOnExit
        >
          <Container>
            <WrappedRole {...props} />
          </Container>
        </CSSTransition>
      ) : turn === "day" ? (
        <CSSTransition
          in={turn === "day"}
          classNames="page"
          timeout={500}
          unmountOnExit
        >
          <ChatArea />
        </CSSTransition>
      ) : (
        <h1>Anda menemukan bug horeee</h1>
      )}
    </>
  );
};

export default withTurn;
